import { z } from 'zod';
import { InterimCareSummarySupportStatus } from '../../../enums';
import { dateValidation } from '../../../../validation';

export const InterimCareSummarySupportProgressSchema = z.object({
  service: z.object({
    id: z.string().min(1),
    name: z.string().min(1),
    professionalType: z.string().optional(),
  }),

  progress: z.string().optional(),

  appointments: z.array(
    z.object({
      id: z
        .string('Appointment status is required')
        .min(1, 'Appointment status is required'),
      date: dateValidation().nullish(),
      status: z.enum(
        InterimCareSummarySupportStatus,
        'Appointment status is required',
      ),
    }),
  ),
});

export type InterimCareSummarySupportProgress = z.infer<
  typeof InterimCareSummarySupportProgressSchema
>;
